export enum GlucoseActionType {
    PAGINATE_GLUCOSE = 'paginate_glucose',
}